module.exports = __webpack_public_path__ + "img/User.a5d9d0af.svg";